import React, { PureComponent } from 'react';
import DatePicker from 'react-datepicker';
import i18next from 'i18next';
import classnames from 'classnames';

export default class DatePickerWrapper extends PureComponent {
  constructor(props) {
    super(props);

    this.state = { error: false };

    this.onChange = this.onChange.bind(this);
    this.clearError = this.clearError.bind(this);
  }

  onChange(date) {
    const { onChange } = this.props;

    this.clearError();

    if (typeof onChange === 'function') {
      onChange(date);
    }
  }

  get error() {
    return this.state.error;
  }

  set error(newValue) {
    this.setState({
      error: newValue,
    });
  }

  clearError() {
    this.setState({
      error: false,
    });
  }

  render() {
    const {
      id,
      selected,
      placeholderText = i18next.t('placeholder.date'),
      dateFormat = 'DD.MM.YYYY',
      className,
      disabled = false,
      errorClassName,
    } = this.props;

    const { error } = this.state;

    const datePickerClassName = classnames(
      'input-component__field',
      { 'input-component__field_error': error },
      className
    );

    const errorClassNames = classnames('input-component__error', errorClassName);

    return (
      <div className="input-component datepicker-form-item">
        <DatePicker
          id={id}
          selected={selected}
          onChange={this.onChange}
          placeholderText={placeholderText}
          dateFormat={dateFormat}
          className={datePickerClassName}
          disabled={disabled}
        />
        {
          error && error !== true ? (
            <div
              className={errorClassNames}
              title={error}
            >
              {error}
            </div>
          ) : null
        }
      </div>
    );
  }
}
